/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { gamesAction, profileAction } from "@redux/modules";

// Components
import showErrMessage from "@components/ShowErrMessage";

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Bootstrap
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

// Styles
import "./styles.scss";

// Images
import BgDots from "@assets/images/games/bg-pattern.png";
import Girls from "@assets/images/games/lucky-wheel/girls.png";
import Point from "@assets/images/games/who-wants-score/point.png";
import PointRed from "@assets/images/games/who-wants-score/point-red.png";
import Gift from "@assets/images/games/who-wants-score/gift.png";
import Box from "@assets/images/games/who-wants-score/box.png";

// CountdownCircleTimer
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

const GameWhoWantsScore = () => {
  const dispatch = useDispatch();

  // Game WWS
  const wws = useSelector((store) => store.games.wws);

  // Game WWS Control
  const wwsControl = useSelector((store) => store.games.wwsControl);

  // Game WWS wwsStart
  const wwsStart = useSelector((store) => store.games.wwsStart);
  const [currentQuestionId, setCurrentQuestionId] = useState(null);

  // Game WWS Bonus
  const wwsBonus = useSelector(store => store.games.wwsBonus);

  const [selectedAnswer, setSelectedAnswer] = useState(null);

  const [btnDisabled, setBtnDisabled] = useState(false);

  // Start Game
  const [gameStarted, setGameStarted] = useState(false);

  // Game is Finish?
  const [isFinish, setIsFinish] = useState(false);

  // Response Message
  const [responseMessage, setResponseMessage] = useState("");
  const [isCorrectAnswer, setIsCorrectAnswer] = useState(false);
  const [isTimeout, setIsTimeout] = useState(false);

  // Timer Defaults
  const [timerColors] = useState(["#76e17b", "#F7B801"]);
  const [timerColorsTime, setTimerColorsTime] = useState([90, 0]);
  const [timerDuration, setTimerDuration] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  const [point, setPoint] = useState(null);
  const [callFix, setCallFix] = useState(false);

  // CountdownTimer When Complete
  const handleTimerComplete = () => {    
    if (!gameStarted || !currentQuestionId) {
      console.log("Timer tamamlandı ama oyun başlamamış veya soru ID yok");
      setIsTimerRunning(false);
      return;
    }

    setIsTimerRunning(false);
    
    setTimeout(() => {
      dispatch(gamesAction.wwsSaveAnswer(currentQuestionId))
        .then((res) => {
          console.log("Timeout API yanıtı:", res);
          if (res.isHttpSuccess) {
            setIsFinish(true);
            setIsTimeout(true);
            setTimerDuration(0);
            setResponseMessage(res.data?.responseText || "Zamanında cevaplayamadınız!");
          }
        })
        .catch((err) => {
          console.log("Timeout API hatası:", err);
          if (err.isHttpError) {
            setIsFinish(true);
            setIsTimeout(true);
            setTimerDuration(0);
            setResponseMessage("Zamanında cevaplayamadınız!");
          }
        });
    }, 1000);
  };

  // Begin Game
  const handleBeginGame = () => {
    if (gameStarted) return;

    dispatch(gamesAction.getWwsStart())
      .then((res) => {
        if (res.isHttpSuccess && res.data) {
          const questionId = res.data?.whoWantsScoreQuestionDTOList?.[0]?.id;
          console.log("Oyun başlatıldı, soru ID:", questionId);
          console.log("Soru verisi:", res.data);
          
          if (questionId) {
            setCurrentQuestionId(questionId);
            setGameStarted(true);
            dispatch(gamesAction.getWwsControl())
              .then((controlRes) => {
                if (controlRes.isHttpSuccess && controlRes.data?.remainTime) {
                  const remainTime = parseInt(controlRes.data.remainTime);
                  console.log("Timer süresi ayarlanıyor:", remainTime);
                  setTimerDuration(remainTime);
                  setTimerColorsTime([remainTime, 0]);
                  setIsTimerRunning(true);
                }
              });
          } else {
            console.error("Soru ID bulunamadı");
            showErrMessage("Soru yüklenirken bir hata oluştu. Lütfen tekrar deneyiniz.");
          }
        }
      })
      .catch((err) => {
        console.error("Oyun başlatma hatası:", err);
        showErrMessage("Oyun başlatılırken bir hata oluştu. Lütfen tekrar deneyiniz.");
      });
  };

  // Timer'ı sıfırla
  const resetTimer = () => {
    setIsTimerRunning(false);
    setTimerDuration(0);
  };

  // Oyun bittiğinde timer'ı sıfırla
  useEffect(() => {
    if (isFinish) {
      resetTimer();
    }
  }, [isFinish]);

  const handleWwsSaveAnswer = (e) => {
    e.preventDefault();
    
    if (selectedAnswer) {
      setBtnDisabled(true);
      dispatch(gamesAction.wwsSaveAnswer(selectedAnswer))
      .then((response) => {
        // Success
        if (response.isHttpSuccess) {
          let message = response?.data?.responseText;
          message = message.replace("{point}", response?.data?.score);
          setResponseMessage(message);
          setTimerDuration(0);
          setIsTimerRunning(false);
          
          if (response?.data?.score) {
            setPoint(response?.data?.score);
          }

          if (response?.data?.answerTrue === true) {
            setIsCorrectAnswer(true);
            setIsFinish(true);
            setTimeout(() => {
              dispatch(profileAction.getLoginUserDetail());
            }, 2000);
          } else if (response?.data?.answerFalse === true) {
            setIsFinish(true);
            setIsCorrectAnswer(false);
          } else if (response?.data?.answerTimeOut === true) {
            setIsTimeout(true);
            setIsFinish(true);
          }
        }
      })
      .catch((err) => {
        // Error
        if (err.isHttpError) {
          showErrMessage(err.message || "Bir hata oluştu. Lütfen tekrar deneyiniz.");
        }
      });
    } else {
      showErrMessage("Lütfen bir seçenek seçiniz!");
    }
  };

  // GET WWS
  useEffect(() => {
    dispatch(gamesAction.getWws());
    dispatch(gamesAction.getWwsControl());

    return () => {};
  }, [dispatch]);

  // Defaults
  useEffect(() => {
    let isMounted = true;
    
    if (wwsControl?.gameConditionStatus === "CONTINUES" && 
      wwsControl.remainTime > 0 && 
      !callFix && 
      !gameStarted &&
      isMounted) {
      setCallFix(true);
      handleBeginGame();
    }
    
    return () => {
      isMounted = false;
    };
  }, [wwsControl]);

  useEffect(() => {
    if (wwsControl?.remainTime > 0 && gameStarted && currentQuestionId) {
      setTimerDuration(wwsControl.remainTime);
      setTimerColorsTime([wwsControl.remainTime, 0]);
      setIsTimerRunning(true);
    } else {
      setIsTimerRunning(false);
    }
  
    return () => {}
  }, [wwsControl, gameStarted, currentQuestionId])
  

  // Defaults
  useEffect(() => {
    let isMounted = true;
    
    if (wwsControl?.gameConditionStatus === "CONTINUES" && 
        wwsControl.remainTime > 0 && 
        !callFix && 
        !gameStarted &&
        isMounted &&
        currentQuestionId) {
          debugger;
      setCallFix(true);
      handleBeginGame();
    }

    if (wwsControl?.remainTime > 0 && gameStarted && currentQuestionId) {
      setTimerDuration(wwsControl.remainTime);
      setTimerColorsTime([wwsControl.remainTime, 0]);
      setIsTimerRunning(true);
    } else {
      setIsTimerRunning(false);
    }
    
    return () => {
      isMounted = false;
    };
  }, [wwsControl, gameStarted, currentQuestionId]);

  // GET WWS BONUS
  useEffect(() => {
    if (wws?.id) {
      dispatch(gamesAction.getWwsBonus(wws.id));
    }
  }, [wws]);

  return (
    <>
      <main className="main-container game-who-wants-score">
        <Header />
        
        <section
          className="games-page page-container wheel-page who-wants-score-page"
          id="backgroundPattern"
          style={{ backgroundImage: wws?.backgroundPattern }}
        >
          <div
            className="games-page-introduction"
            style={{ backgroundImage: `url(${BgDots})` }}
            id="backgroundImage"
          >
            <div
              className={
                gameStarted === true && isFinish === false
                  ? "d-block game-timer"
                  : "d-none game-timer"
              }
            >
              <h3 className="text-center">Kalan Süre</h3>
              <div className="game-countdown text-center ml-auto mr-auto">
                {timerColors && timerColorsTime && wws && wws.remainTime &&
                timerDuration && timerDuration > 0 && gameStarted && !isFinish && (
                  <CountdownCircleTimer
                    key={timerDuration}
                    isPlaying={isTimerRunning}
                    duration={timerDuration}
                    initialRemainingTime={timerDuration}
                    colors={timerColors}
                    colorsTime={timerColorsTime}
                    size={80}
                    strokeWidth={8}
                    onComplete={() => handleTimerComplete()}
                  >
                    {({ remainingTime }) => remainingTime}
                  </CountdownCircleTimer>
                )}
              </div>

              <div className="text-center">
                {wwsBonus?.totalPoint >= 0 &&   
                  <div className="text-center mt-3">
                    <h3 className="m-0">Toplam Puan</h3>
                    <p className="text-center">{wwsBonus?.totalPoint}</p>
                  </div>
                }
              </div>
            </div>

            <Container>
              {gameStarted === false && isFinish === false && (
                <Row className="justify-content-md-center text-center text-white">
                  {wws && (
                    <Col xs="12">
                      <div className="d-flex flex-column justify-content-center align-items-center wrapper-wp-start">
                        <div className="games-page-circle mb-md-5 mb-3">
                          <img src={wws?.icon} alt={wws?.title} />
                        </div>
                        <h2 className="mt-5 mb-0 p-0 text-white">{wws?.title}</h2>
                        <p className="mb-3">{wws?.description}</p>

                        <h2 className="mt-5 mb-0 p-0 text-white">Oyun Durumu</h2>

                        {wwsBonus?.totalPoint >= 0 &&   
                          <div>Kazanılan Toplam Puan: {wwsBonus?.totalPoint}</div>
                        }

                        <div className="wrapper-point-list">

                          {wwsBonus?.weeks?.length > 0 && 
                            wwsBonus?.weeks?.map((week) => (
                              <div className="wrapper-point" key={week?.questionId}>
                                {week?.isCorrectAnswer === false ?
                                  <img src={PointRed} className="point active" style={{ filter: `grayscale(0.3)` }} alt="Point" /> : 
                                  <img src={Point} className={week?.isCorrectAnswer === true ? "point active" : "point"} alt="Point" />
                                }
                                
                                <div className="point-area">
                                  <span>{week?.title}</span>
                                  <span className="point-text">{week?.score}</span>
                                  <span>Puan</span>
                                </div>
                              </div>
                            ))
                          }

                          {wwsBonus?.bonusScore && 
                            <div className="wrapper-point">
                              {wwsBonus.isBonus === "NOTWON" &&
                                <img src={PointRed} className="point active"  style={{ filter: `grayscale(0.3)` }} alt="Point" />
                              }

                              {wwsBonus.isBonus === "WON" && 
                                <img src={Point} className="point active" alt="Point" />
                              }

                              {wwsBonus.isBonus === "EMPTY" && 
                                <img src={Point} className="point" alt="Point" />
                              }
                              
                              <div className="point-area">
                                <span>Hediye</span>
                                <span className="point-text">+{wwsBonus?.bonusScore}</span>
                                <span>Puan</span>
                              </div>

                              <img src={Gift} className="gift" alt="Gift" />
                              <img src={Box} className="box" alt="Box" />
                            </div>
                          }
                        </div>

                        {wwsControl?.gameConditionStatus !==
                            "NOT_PLAYED" ? (
                            <div className="mt-3">
                              {(() => {
                                switch (wwsControl?.gameConditionStatus) {
                                  case "PLAYED":
                                    return "Daha önceden yarışmaya katıldınız. Lütfen daha sonra tekrar deneyiniz.";
                                  case "CONTINUES":
                                    return "Yarışma devam ediyor. Başarılar!";
                                  case "NO_GAME":
                                    return "Şu anda aktif oyun bulunmamaktadır. Lütfen daha sonra tekrar deneyiniz.";
                                  case "TIMEOUT":
                                    return "Cevaplama süresi doldu. Bir sonraki yarışmada görüşmek üzere!";
                                  case "NO_QUESTION":
                                    return "Yeni bir soru bulunamadı. Soru gününde görüşmek üzere!";
                                  default:
                                    return "Durum belirlenemedi. Lütfen daha sonra tekrar deneyiniz.";
                                }
                              })()}
                            </div>
                          ) : (
                            <Button
                              onClick={() => handleBeginGame()}
                              className="btn btn-success mt-0 mb-0 text-white"
                            >
                              {wws?.buttonText}
                            </Button>
                          )}
                      </div>
                    </Col>
                  )}
                </Row>
              )}

              {gameStarted === true && isFinish === false && (
                <div className="wrapper-question-start">
                  {/* Question */}
                  <div className="wrapper-question">
                    <Form onSubmit={handleWwsSaveAnswer}>
                      <Form.Group as={Row} className="text-center">
                        {wwsStart?.whoWantsScoreQuestionDTOList?.length > 0 && (
                          <Form.Label
                            as="legend"
                            column
                            sm={12}
                          >
                            {
                              wwsStart?.whoWantsScoreQuestionDTOList[0]?.description
                            }
                          </Form.Label>
                        )}

                        <Col sm={12} className="mb-3">
                          <div className="wrapper-answer-options">
                            {wwsStart?.whoWantsScoreQuestionDTOList?.length > 0 && 
                            wwsStart?.whoWantsScoreQuestionDTOList[0]?.whoWantsScoreChoiceDTOList?.length > 0 && 
                            wwsStart?.whoWantsScoreQuestionDTOList[0]?.whoWantsScoreChoiceDTOList?.map(
                              (answer, aIndex) => {
                                return (
                                  <Form.Check
                                    key={aIndex}
                                    type="radio"
                                    label={answer.description}
                                    name={"answer"}
                                    value={answer.id}
                                    id={answer.id}
                                    onClick={() =>
                                      setSelectedAnswer(
                                        answer.id
                                      )
                                    }
                                  />
                                );
                              }
                            )}
                          </div>

                          <Button
                            variant="primary"
                            className="btn btn-success text-white mt-4"
                            type="submit"
                            disabled={btnDisabled}
                          >
                            Cevapla
                          </Button>
                        </Col>
                      </Form.Group>
                    </Form>
                  </div>
                  {/* End Question && Answers */}
                </div>
              )}

              {isFinish === true && (
                <Row className="justify-content-md-center text-center">
                  {isTimeout === true ? (
                    <>
                      <h1>Zamanında Cevaplayamadınız!</h1>
                      {responseMessage && (
                        <p>{responseMessage}</p>
                      )}
                      <div className="wrapper-reward active">
                        <img src={Girls} alt="" />
                        <h4>0</h4>
                      </div>
                    </>
                  ) : (
                    <>
                      {isCorrectAnswer === true ? (
                        <Col
                          xs={12}
                          className="text-center find-mate-win active"
                        >
                          <h1>Tebrikler Kazandınız!</h1>
                          <p className="!m-0">
                            {responseMessage}
                          </p>

                          <div className="wrapper-reward active">
                            <img src={Girls} alt="" />
                            <h4>{point}</h4>
                          </div>
                        </Col>
                      ) : (
                        <Col
                          xs={12}
                          className="text-center find-mate-win active"
                        >
                          <h1>Kaybettiniz!</h1>
                          <p className="!m-0">
                            {responseMessage}
                          </p>

                          <div className="wrapper-reward active">
                            <img src={Girls} alt="" />
                            <h4>0</h4>
                          </div>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              )}

            </Container>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default GameWhoWantsScore;
